import { Col, Row, SearchField, TinyTable } from '@rematter/ui-web';
import { useAtom, useAtomValue } from 'jotai';
import { LucideMapPin, LucideLayers, LucideShieldCheck } from 'lucide-react';

import * as complianceRulesState from '../../_state/complianceRules.state';
import { useSettingsLocation } from '../../_state/settingsModule.state';
import { useTranslations } from '../../i18n/useTranslations';
import { SettingsSubmodule } from '../_layouts/SettingsSubmodule';
import { SettingsContent } from '../_shared/SettingsContent';

export const ComplianceRulesRootView = () => {
  const t = useTranslations();
  const [, setLocation] = useSettingsLocation();
  const facilityList = useAtomValue(complianceRulesState.$facilityListForRules);
  const facilityRuleCounts = useAtomValue(
    complianceRulesState.$facilityRuleCounts,
  );
  const [searchTerm, setSearchTerm] = useAtom(
    complianceRulesState.$complianceRulesSearchTerm.value,
  );

  return (
    <Col className="@ComplianceRulesRootView h-full">
      <SettingsSubmodule
        title={t.complianceView.rules.title}
        subtitle={t.complianceView.rules.subtitle}
        tabs={null}
      >
        <SettingsContent className="h-full">
          <Col gap4 className="h-full">
            <Row gap2>
              <SearchField
                value={searchTerm}
                onChange={setSearchTerm}
                autoFocus
                placeholder={
                  t.complianceView.rules.facilityList.search.placeholder
                }
              />
            </Row>
            <TinyTable
              rowKey={(row) => row.id}
              isLoading={facilityList.isLoading}
              error={facilityList.error}
              onRowClick={(row) => setLocation(`/compliance/rules/${row.id}`)}
              columns={[
                {
                  key: 'name',
                  label: t.complianceView.rules.facilityList.columns.name,
                  icon: LucideMapPin,
                  cell: (row) => <div className="truncate">{row.name}</div>,
                },
                {
                  key: 'type',
                  label: t.complianceView.rules.facilityList.columns.type,
                  icon: LucideLayers,
                  width: 150,
                  cell: (row) => row.type,
                },
                {
                  key: 'activeRules',
                  label:
                    t.complianceView.rules.facilityList.columns.activeRules,
                  icon: LucideShieldCheck,
                  width: 120,
                  cell: (row) => (
                    <span className="tabular-nums">
                      {facilityRuleCounts.get(row.id) ?? 0}
                    </span>
                  ),
                },
              ]}
              data={facilityList.data ?? []}
            />
          </Col>
        </SettingsContent>
      </SettingsSubmodule>
    </Col>
  );
};
